import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const MainLayout: FC<{}> = () => {
  return (
    <Box className="body">
      <Outlet />
    </Box>
  );
};

export default MainLayout;
